module.exports = __webpack_public_path__ + "img/tow_1.8ada93fd.png";